import { makeAwsSignedRequest } from '../ApiService';

export interface DiagnosticProcessorTrendPoint {
    date: string;
    count: number;
}

export interface DiagnosticProcessorTrendSummary {
    processor: string;
    firstCount: number;
    lastCount: number;
    absoluteChange: number;
    percentageChange?: number | null;
    peakCount: number;
    peakDate?: string | null;
    dailyCounts: DiagnosticProcessorTrendPoint[];
}

export interface DiagnosticProcessorTrendResponse {
    generatedAt: string;
    windowStart?: string | null;
    windowEnd?: string | null;
    daysRequested: number;
    snapshotsAnalyzed: number;
    topSpikingProcessor?: string | null;
    processors: DiagnosticProcessorTrendSummary[];
}

interface GetDiagnosticProcessorTrendsRequest {
    days: number;
    clientIds?: string[];
    processors?: string[];
    startTime?: string;
    endTime?: string;
}

export const DiagnosticTrendApi = {
    getProcessorTrends: (
        stage: string,
        realm: string,
        request: GetDiagnosticProcessorTrendsRequest,
    ): Promise<DiagnosticProcessorTrendResponse> => {
        const params = new URLSearchParams({
            days: String(request.days),
        });

        if (request.clientIds && request.clientIds.length > 0) {
            params.set('clientId', request.clientIds.join(','));
        }

        if (request.processors && request.processors.length > 0) {
            params.set('processor', request.processors.join(','));
        }

        if (request.startTime) {
            params.set('startTime', request.startTime);
        }

        if (request.endTime) {
            params.set('endTime', request.endTime);
        }

        return makeAwsSignedRequest(stage, realm, `diagnostic/processor-trends?${params.toString()}`);
    },
};
